import { render, staticRenderFns } from "./DeviceStatistics.vue?vue&type=template&id=ff92b3fa&scoped=true"
import script from "./DeviceStatistics.vue?vue&type=script&lang=js"
export * from "./DeviceStatistics.vue?vue&type=script&lang=js"
import style0 from "./DeviceStatistics.vue?vue&type=style&index=0&id=ff92b3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff92b3fa",
  null
  
)

export default component.exports